import { defineStore, acceptHMRUpdate } from 'pinia';
import useUsersStore from '@/stores/users';

const store = defineStore('notifications', {
  state: () => ({
    all: [],
  }),

  getters: {
    byId(state) {
      return state.all.reduce((acc, notif) => {
        acc[notif.id] = notif;
        return acc;
      }, {});
    },
    unseen: state => state.all.filter(notif => ! notif.seen_at),
  },

  actions: {
    load() {
      return window.apiSrv.call('notifications', 'index').then((response) => {
        const usersStore = useUsersStore();
        response.data.notifications.forEach((notif) => {
          notif.user = usersStore.getUserById(notif.created_by);
        });
        this.all = response.data.notifications;
      });
    },
    seen({ filters } = {}) {
      if (! this.all.filter(notif => ! notif.seen_at).length) return Promise.resolve('nothing to do');
      return window.apiSrv.call('notifications/seen', 'store', filters || {}).then((response) => {
        const usersStore = useUsersStore();
        response.data.notifications.forEach((notif) => {
          notif.user = usersStore.getUserById(notif.created_by);
        });
        this.all = response.data.notifications;
      });
    },
  },
});

export default store;

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(store, import.meta.hot));
}
